// src/pages/TrialBalance/index.js
import React, { useRef } from "react";
import { useSelector } from "react-redux";
import { DownloadOutlined, PrinterOutlined } from "@ant-design/icons";
import { App, Button, Card, Flex, Grid, Typography } from "antd";
import TrialBalanceFilters from "./components/TrialBalanceFilters";
import TrialBalanceTable from "./components/TrialBalanceTable";
import ReportDom from "../../../components/common/ReportDom";
import { useReactToPrint } from "react-to-print";
import { exportTrialBalanceCsv } from "./components/exportTrialBalanceCsv";
import { useTrialBalanceData } from "./components/useTrialBalanceData";

const { Title } = Typography;

const TrialBalance = () => {
  const { message } = App.useApp();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const { filters,balances  } = useSelector((state) => state.trialBalance);

  const reportRef = useRef(null);
  const { dataSource, currency } = useTrialBalanceData();

  const handlePrint = useReactToPrint({
    contentRef: reportRef,
    documentTitle: "Trial Balance",
    removeAfterPrint: true,
  });
  const handleDownloadCsv = () => {
    exportTrialBalanceCsv({
      dataSource,
      currency,
      title: "Trial Balance",
      filename: "trial_balance",
    });
  };

  const hasData = Object.keys(balances).length > 0;

  return (
    <div className="p-4">
      <Card
        className="shadow-md rounded-xl mb-4"
        title={
          <Title level={4} style={{ margin: 0 }}>
            Trial Balance
          </Title>
        }
               extra={
          <Flex gap={8}>
            {hasData && (
              <Button icon={<DownloadOutlined />} onClick={handleDownloadCsv}>
                {!screens.xs && "CSV"}
              </Button>
            )}
            <Button type="primary" icon={<PrinterOutlined />} onClick={handlePrint}>
              {!screens.xs && "Print"}
            </Button>
          </Flex>
        }
        styles={{
          header: { borderBottom: "none", padding: "12px 16px" },
          body: { padding: 0 },
        }}
      />

      <TrialBalanceFilters messageApi={message} />

      <Card className="shadow-md rounded-xl">
        <TrialBalanceTable />
      </Card>

      {/* Hidden print layout */}
      <div style={{ position: "absolute", top: "-9999px", left: "-9999px" }}>
        <ReportDom
          ref={reportRef}
          title="Trial Balance"
          mode="report-page"
          filters={filters}
          renderTable={() => <TrialBalanceTable printMode={true} />}
        />
      </div>
    </div>
  );
};

export default TrialBalance;
